import React from "react";
import Modal from "../Modal.jsx";

export default class DffModal extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Modal title="Dubai Future Foundation" id="dff" onClose={this.props.onClose}>
          <img
              src="/img/portfolio/dff.gif"
              className="img-responsive img-centered"
              alt=""
          />
        <p>
            As part of a team building web applications for the government of the United Arab Emirates,
            I worked on several digital services in 2019 and 2020. These included a platform that streamlined
            business visa applications for applicants and reviewers, and a single sign-on system for government websites.
        </p>

        <ul className="list-inline item-details">
          <li>
            Client:
            <strong>
              &nbsp;Motius
            </strong>
          </li>
          <li>
            Date:
            <strong> 2019-2020 </strong>
          </li>
        </ul>
      </Modal>
    );
  }
}
